import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "loren-error-template",
    imports: [TranslocoPipe],
    templateUrl: "./loren-error-template.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loren-error-template.component.scss"]
})
export class LorenErrorTemplateComponent {
  private router = inject(Router);

  @Input() title: string;
  @Input() message: string;
  @Input() button = true;

  goHome() {
    this.router.navigate(["/"]);
  }
}
